import zod from "zod";
import { uuid } from "./common";
import { DataTypeEnum } from "../models/contextInstance";


export const contextVariableValueSchema = zod.union([zod.string(), zod.boolean(), zod.number(), zod.null(), zod.object({ label: zod.string(), value: zod.string() }), zod.object({}, zod.array(zod.any()))]);

export const createContextInstanceVariableSchema = zod.object({
    key: zod.string(),
    value: zod.string().nullable(),
});

export const createContextInstanceSchema = zod.object({
    variables: zod.array(createContextInstanceVariableSchema),
});

export const contextInstanceVariableSchema = zod.object({
  id: uuid,
  key: zod.string(),
  value: contextVariableValueSchema,
  isArray: zod.boolean(),
  readOnly: zod.boolean(),
  dataType: zod.nativeEnum(DataTypeEnum),
  jsonSchema: zod.string().nullable(),
})
 
export const contextInstanceSchema = zod.object({
    id: uuid,
    variables: zod.array(contextInstanceVariableSchema)
  });

export type CreateContextInstanceVariableType = zod.infer<
    typeof createContextInstanceVariableSchema
>;
export type CreateContextInstanceType = zod.infer<typeof createContextInstanceSchema>;
export type ContextInstanceType = zod.infer<typeof contextInstanceSchema>;
export type ContextInstanceVariableType = zod.infer<typeof contextInstanceVariableSchema>;
export type ContextVariableValueType = zod.infer<typeof contextVariableValueSchema>;
